module.exports = __webpack_public_path__ + "band_15_son.3f9875da.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/band_15_son.png
// module id = u283
// module chunks = 0